// src/components/prompts/TimeSlotPrompt.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import routes from '../routes';
import UserService from '../utils/UserService';
import { useSelector } from 'react-redux';

const TimeSlotPrompt = ({ isOpen, onClose, setShouldShowPrompt }) => {
  const navigate = useNavigate();
  const accountType = useSelector(
    (state) => state?.user?.userInfo?.userTypeTitle,
  );

  const handleSetTimeSlot = () => {
    onClose();
    // UserService.setTimeSlotPromptDismissed();
    navigate('/bookings', {
      state: {
        fromTimeSlotPrompt: true,
      },
    });
  };

  const handleDismiss = () => {
    setShouldShowPrompt(false);
    onClose();
    UserService.setTimeSlotPromptDismissed();
  };

  const location = useLocation();

  const isPublicPage = routes.publicRoutes.some(
    (route) => `/${route.path}` === location.pathname,
  );

  const founderRoutes =
    accountType === 'founder'
      ? routes.foundersRoutes.map((route) => route.path)
      : [];

  const isAdminPage = routes.adminRoutes
    .filter((route) => route.path && !founderRoutes.includes(route.path))
    .some((route) => `/${route.path}` === location.pathname);

  const isBookingPage = location.pathname === '/bookings';

  const isSurveyPage = location.pathname === '/survey';
  const showModal =
    isOpen && !isBookingPage && !isPublicPage && !isAdminPage && !isSurveyPage;

  return (
    <Modal
      zIndex={1500}
      isOpen={showModal}
      onClose={handleDismiss}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        mt={[2, 4]}
        mx={[2, 4]}
        maxW={['90%', '85%', '80%', '600px']}
        borderRadius="lg"
      >
        <ModalHeader fontSize={['lg', 'xl']}>Set Your Availability</ModalHeader>
        <ModalBody>
          <VStack spacing={[3, 4]} align="stretch">
            <Text fontSize={['sm', 'md']}>
              Set your availability so investors can book time with you. You're
              more likely to get noticed and contacted!
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={handleDismiss}
            size={['sm', 'md']}
          >
            Remind Me Later
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSetTimeSlot}
            size={['sm', 'md']}
          >
            Set Time Slot
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TimeSlotPrompt;
